/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_appsync_graphqlEndpoint": "https://iosipfi7sncglolgdbggkl6nkm.appsync-api.eu-north-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-north-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-blthlblihbdwnl7zy7fqhixf34",
    "aws_cognito_identity_pool_id": "eu-north-1:af774ba1-bf73-4bb5-83d8-00e2e31cad74",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_zupZoPaaS",
    "aws_user_pools_web_client_id": "240g06d1q72e9sloq5s19qf6b",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "laniakerie-storage-038e7d7c74829-staging",
    "aws_user_files_s3_bucket_region": "eu-north-1"
};


export default awsmobile;
